import { useQuery } from "react-query";
import { memoirsApiInstance } from "../api/api";
import { selectUser, selectUserToken, setUser } from "../store/slices/auth";
import { useDispatch, useSelector } from "../store/store";
import { User } from "../types/models";

/**
 * The user is stored once, at sign in. Reload it from the API so changes made
 * since (admin rights, confirmation, profile edited by an admin…) are seen
 * without signing in again.
 */
export const useRefreshCurrentUser = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const userToken = useSelector(selectUserToken);

  return useQuery(
    ["current_user", user?.id],
    () => memoirsApiInstance.get<User>(`/users/${user?.id}`),
    {
      enabled: !!user?.id && !!userToken,
      staleTime: 60_000,
      retry: false,
      onSuccess: (freshUser) => {
        dispatch(setUser({ user: freshUser }));
      },
    }
  );
};
